import { Box, Typography, Card, CardContent } from "@mui/material";
import { Analytics as AnalyticsIcon } from "@mui/icons-material";

export default function Analytics() {
    return (
        <Box className="fade-in">
            <Card sx={{
                borderRadius: '16px',
                boxShadow: 1,
                minHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'background.paper'
            }}>
                <CardContent sx={{ textAlign: 'center' }}>
                    <AnalyticsIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                        Analytics Dashboard
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Coming Soon
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}